const translationCa = {
    comu: {
        si: "Si",
        no: "No",
        resetFiltre: "Esborrar filtre",
        detall: "Veure el detall",
        tancar: "Tancar",
        deselecionar: "Desseleccionar tot",
        noRegistres: 'No hi ha registres',
        refrescar: 'Refrescar',
    },
    page: {
        notFound: "No trobat",
    },
    clients: {
        title: "Clients",
        create: "Crear client",
        update: "Modificar client",
    },
    zones: {
        title: "Zones",
        create: "Crear zona",
        update: "Modificar zona",
    },
    zonesUser: {
        title: "Zones d'usuari",
        create: "Crear zona d'usuari",
        update: "Modificar zona d'usuari",
    },
    users: {
        title: "Usuaris",
        create: "Crear usuari",
        update: "Modificar usuari",
        password: {
            title: "Canviar contrasenya",
            caption: "Emplenar només si es vol modificar la contrasenya de l'usuari",
        },
    },
    recursos: {
        title: "Recursos",
        create: "Crear recurs",
        update: "Modificar recurs",
    },
    embarcacions: {
        title: "Embarcacions",
        create: "Crear embarcacio",
        update: "Modificar embarcacio",
    },
    reserves: {
        title: "Reserves",
        titleDetall: "Reserva",
        create: "Crear reserva",
        update: "Modificar reserva",
        readOnly: "Detall de reserva",
        totals: {
            title: "Totals",
            adults: "Adults",
            infants: "Infants",
            bebes: "Bebes",
            efectiu: "Efectiu",
            targeta: "Targeta",
            reserves: "Reserves",
            total: "Total",
        },
        exportarA3: "Descarregar export A3",
        reservaManual: "Aquesta reserva ha estat modificada manualment",
        liniaManual: "Alguna de les línies d'aquesta reserva han estat modificades manualment",
        reservaLiniaManual: "Tant aquesta reserva com alguna de les seves línies han estat modificades manualment",
        altres: 'Altres',
        campsEveret: 'Camps Everet',
        seleccionarTot: 'Seleccionar totes les reserves',
        noTraspassats: {
            aplicat: "S'ha aplicat el filtre dels no traspassats",
            noAplicat: "Número de reserves no traspassades a Everet. Faci clic per a consultar-les",
        },
    },
    reservesDescompte: {
        title: "Descomptes de reserva",
        create: "Crear descomptes de reserva",
        update: "Modificar descomptes de reserva",
    },
    reservesLinia: {
        title: "Linies de reserva",
        create: "Crear linies de reserva",
        update: "Modificar linies de reserva",
    },
    requisitsRecurs: {
        title: "Requisits de recursos",
        create: "Crear requisits de recursos",
        update: "Modificar requisits de recursos",
    },
    requerimentsRecurs: {
        title: "Requeriments de recursos",
        create: "Crear requeriment de recursos",
        update: "Modificar requeriment de recursos",
    },
    productes: {
        title: "Productes",
        create: "Crear producte",
        update: "Modificar producte",
    },
    agendesProducte: {
        title: "Disponibilitat del producte",
        create: "Crear disponibilitat del producte",
        update: "Modificar disponibilitat del producte",
        readOnly: "Detall de disponibilitat del producte",
        tab: {
            taula: 'Taula',
            calendari: 'Calendari',
        },
        actions: {
            planificar: {
                title: 'Planificar',
                tabForm: 'Dades generals',
            },
            seleccionar: 'Seleccionar totes les disponibilitats',
        },
        detall: {
            title: 'Veure detall',
        },
        calendari: {
            switchProductes: "Filtrar per tots els productes",
        },
    },
    parametres: {
        title: 'Paràmetres',
        titleMobil: 'Preu Cuevas per a l\'aplicació mòbil',
        titleComptabilitat: 'Paràmetres per a comptabilitat',
        titleCreuers: 'Paràmetres de Creuers',
        titleVerifactu: 'Paràmetres per a Verifactu',
        titleRegimsIva: 'Paràmetres per a Règims IVA'
    },
    informes: {
        title: 'Informes per zona i venedor',
        create: 'Crear informe',
        update: 'Modificar informe',
        totals: {
            efectiu: 'Efectiu',
            targeta: 'Targeta',
            tiquets: 'Tiquets',
            coves: 'Coves',
            total: 'Import total',
            resultats: 'Resultats',
        },
    },
    informesTripulacio: {
        title: 'Informe de tripulació per recurs i/o embarcació',
        patrons: 'Patrons',
        mecanics: 'Mecànics',
        tripulancio: 'Tripulació',
        marinerFotos: 'Mariner fotos',
        marinerBar: 'Mariner bar',
        tots: 'Tots els rols',
        columnes: {
            nom: 'Nom',
            dies: 'Dies',
            percentatge: 'Percentatge',
        },
    },
    informesEmbarcacio: {
        title: 'Informe de tripulació per embarcació',
        patrons: 'Patrons',
        mecanics: 'Mecànics',
        tripulancio: 'Tripulació',
        columnes: {
            codi: 'Codi',
            nom: 'Nom',
            dies: 'Dies',
            percentatge: 'Percentatge',
        },
    },
    grafics: {
        title: 'Ús de recursos',
        ocupacio: 'Ocupació per recurs i hora',
        alert: 'No hi ha una data seleccionada, si us plau selecciona una data.',
        refrescar: 'Refrescar',
    },
    proveidor: {
        title: 'Proveïdor',
        create: 'Crear proveïdor',
        update: 'Modificar proveïdor',
    },
    centreCost: {
        title: 'Centre de costos',
        create: 'Crear centre de cost',
        update: 'Modificar centre de cost',
    },
    rutes: {
        title: 'Rutes planificades',
        create: 'Crear ruta planificada',
        update: 'Modificar ruta planificada',
        rutesMassives: 'Creació de rutes a partir de disponibilitats',
        resultatsRutes: 'Resultats de la creació de rutes a partir de disponibilitats',
        tabs: {
            punt: {
                title:'Punts de la ruta',
                create: 'Crear punt',
                update: 'Modificar punt',
                observacions: 'Observacions',
            },
            usuari: {
                title: 'Tripulació',
                create: 'Crear tripulant',
                update: 'Modificar tripulant',
            },
            incidencia: {
                title: 'Incidències',
                create: 'Crear incidencia',
                update: 'Modificar incidencia',
            },
        },
    },
    series: {
        title: 'Sèries',
        create: 'Crear una sèrie',
        update: 'Modificar la sèrie',
    },
    terminals: {
        title: 'Terminals',
        create: 'Crear un terminal',
        update: 'Modificar un terminal',
    },
    tripulants: {
        title: 'Tripulants',
        create: 'Crear un tripulant',
        update: 'Modificar un tripulant',
    },
    tripulantRuta: {
        title: 'Ruta-Tripulant',
        create: 'Crear Ruta-Tripulant',
        update: 'Modificar Ruta-Tripulant',
    },
    articles: {
        title: 'Articles',
        create: 'Crear article',
        update: 'Modificar article',
    },
    registresVerifactu: {
        title: "Control d'errors Verifactu",
        create: '',
        update: 'Detall del registre'
    },
    categories: {
        title: 'Categories',
        create: 'Crear categoria',
        update: 'Modificar categoria',
    },
    articleExistencies: {
        title: 'Existències',
        create: 'Crear existència',
        update: 'Modificar existència',
        action: {
            operacioCompra: {
                quantitat: 'Quantitat',
                quantitatPlaceHolder: 'Quantitat d\'articles comprats',
            },
            operacioInventari: {
                quantitat: 'Quantitat',
                quantitatPlaceHolder: 'Quantitat d\'articles',
            },
            operacioTraspas: {
                quantitat: 'Quantitat',
                quantitatPlaceHolder: 'Quantitat d\'articles a traspasar',
            }
        },
    },
    everet: {
        title: 'Everet',
        versio: 'Versió',
        estat: 'Estat',
        anarEveret: 'Anar a Everet',
        actiu: 'Actiu',
        inactiu: 'Inactiu',
    },
    versio: {
        title: 'Versió',
        subTitle: 'Informació de la versió',
        nom: 'Nom del projecte',
        versio: 'Versió',
        data: 'Data',
        declaracioResponsable: 'Declaració responsable',
    },
    operacio: {
        title: 'Operacions',
        titleDetall: 'Operació',
        create: 'Crear operació',
        update: 'Modificar operació',
        readOnly: 'Detall d\'operació',
        operacioManual: "Aquesta operació ha estat modificada manualment",
        liniaManual: "Alguna de les línies d'aquesta operació han estat modificades manualment",
        operacioLiniaManual: "Tant aquesta operació com alguna de les seves línies han estat modificades manualment",
        noTraspassats: {
            aplicat: "S'ha aplicat el filtre dels no traspassats",
            noAplicat: "Numero de reserves no traspassades a Everet. Faci clic per a consultar-les",
        },
        totals: {
            title: "Totals",
            efectiu: "Efectiu",
            targeta: "Targeta",
            operacions: "Operacions",
            total: "Total",
        },
        linies: {
            title: 'Línies d\'operació',
            create: 'Crear línia d\'operació',
            update: 'Modificar línia d\'operació',
            view: 'Línea de operación',
            liniesArticle: {
                title: 'Línies d\'article',
                create: 'Crear línies d\'article',
                update: 'Modificar línies d\'article',
            },
            totals: {
				preuMig : 'Preu mig',
				totalQuantitat: 'Quantitat total'
			},
        },
        action: {
            campAbonament: 'Quantitat a abonar',
            campPreuAbonament: 'Preu per quantitat a reemborsar',
            tooltipCampAbonament: 'Índica la quantitat d\'articles que vols abonar',
            tooltipCampPreuAbonament: 'Índica el preu individual de cada quantitat que vols reemborsar',
            seleccionarTot: 'Seleccionar totes les reserves',
        },
    },
    opcions: {
        title: 'Opcions',
        create: 'Crear una opció',
        update: 'Modificar una opció',
    },
    articlesOpcions: {
        title: 'Articles / opcions',
        create: 'Crear article / opció',
        update: 'Modificar article / opció',
        opcioSeleccionada: 'Articles seleccionables per a l\'opció',
        tooltipTancarOpcio: 'Tancar opció seleccionada',
    },
    consumTripulacio: {
        title: 'Consum de tripulació',
        create: 'Crear consum de tripulació',
        update: 'Modificar consum de tripulació',
        readOnly: 'Detall de consum de tripulació',
        totals: {
            title: "Totals",
            efectiu: "Efectiu",
            targeta: "Targeta",
            operacions: "Operacions",
            total: "Total",
        },
    },
    talonaris: {
        title: 'Talonaris',
        create: 'Crear talonari',
        update: 'Modificar talonari',
    },
    bonosTalonari: {
        title: 'Bons de talonaris',
        create: 'Crear bo de talonari',
        update: 'Modificar bo de talonari',
        tooltipModificarEstat: 'Filtrar per tipus afiliat i selecciona registres per a poder executar l\'acció de modificar estat',
        anarTalonari: 'Veure talonari',
    },
    controlFotografia: {
        title: 'Control de fotografia',
        create: 'Crear control de fotografia',
        update: 'Modificar control de fotografia',
        totals: {
            postalsFetes: 'Postals fetes',
            postalsVenudes: 'Postals venudes',
            importPostals: 'Import postals',
            clauersFets: 'Clauers fets',
            clauersVenuts: 'Clauers venuts',
            importClauers: 'Import clauers',
            totalVenut: 'Total venut',
            totalControlsFotografia: 'Total control de fotografia',
            importTargeta: 'Import targeta',
            importEfectiu: 'Import efectiu',
            importTotal: 'Import total',
        },
    },
    registreVerifactu: {
        title: "Detalls del registre",
        correccioErrorsRemissioTitle: "Correcció d''errors en la remissió a Verifactu",
        factura: 'Anar a la factura',
        numSerieFactura: "Número factura",
        fechaExpedicionFactura :"Data d''expedició",
        importeTotal :"Import total",
        enviamentDataEnviament :"Data d''enviament",
        respostaEstadoRegistro :"Estat del registre",
        respostaDescripcionError :"Descripció de l''error",
        operacion :"Operació",
        idVersion :"Id versió",
        idEmisorFactura :"Emissor factura",
        sifNumeroInstalacion :"Número d''instal·lació",
        secuencia :"Seqüencia",
        tipoFactura :"Tipus de factura",
        cuotaTotal :"Quota total",
        primerRegistro :"Primer registre",
        tipoHuella :"Tipus d''empremta",
        sifNif :"NIF de l''expedidor",
        sifNombre :"Nom Sif",
        sifId :"Sif id",
        sifVersion :"Vesio sif",
        sifTipoUsoPosibleSoloVerifactu :"Tipus d''ús possible sols Verifactu",
        sifTipoUsoPosibleMultiOt :"Tipus d''ús possible multi OT",
        sifIndicadorMultiplesOT :"Indicador sif multiples OT",
        recuperat :"Recuperat",
        sifEmpresa :"Sif empresa",
        maxNumSerieId :"Màxim número serie",
        createdBy :"Usuari de creació",
        createdDate :"Data de creació",
        httpRequestAvailable :"Http request available",
        tipus :"Tipus",
        registroAnteriorFechaExpedicionFactura :"Data d''expedió del registre anterior",
        nombreRazonEmisor :"Raó emissor",
        descripcionOperacion :"Descripció de l''operació",
        huella :"Empremta",
        sifNombreRazon :"Nom raó sif",
        urlVerificacion :"URL de verificació",
        description :"Descripció",
        botoEncongir :"Amagar camps",
    	botoDesplegar :"Mostrar més camps",
        desglose: {
			title: 'Desglossament',
        	impuesto: "Impost",
        	claveRegimen: "Clau del règim",
        	calificacionOperacion: "Calificació de l''operació",
        	tipoImpositivo: "Tipus impositiu",
        	baseImponibleOimporteNoSujeto: "Base imposable import no subjecte",
        	cuotaRepercutida: "Quota repercutida",
        	impostos: {
	            IMP_01: "IVA",
	            IMP_02: "IPSI",
	            IMP_03: "IGIC",
	            IMP_05: "Altres"
	        },
			clausRegim: {
			    CLR_01: "Operación de régimen general",
			    CLR_02: "Exportación",
			    CLR_03: "Operaciones a las que se aplique el régimen especial de bienes usados, objetos de arte, antigüedades y objetos de colección",
			    CLR_04: "Régimen especial del oro de inversión",
			    CLR_05: "Régimen especial de las agencias de viajes",
			    CLR_06: "Régimen especial grupo de entidades en IVA (Nivel Avanzado)",
			    CLR_07: "Régimen especial del criterio de caja",
			    CLR_08: "Operaciones sujetas al IPSI / IGIC (Impuesto sobre la Producción, los Servicios y la Importación / Impuesto General Indirecto Canario)",
			    CLR_09: "Facturación de las prestaciones de servicios de agencias de viaje que actúan como mediadoras en nombre y por cuenta ajena (D.A.4ª RD1619/2012)",
			    CLR_10: "Cobros por cuenta de terceros de honorarios profesionales o de derechos derivados de la propiedad industrial, de autor u otros por cuenta de sus socios, asociados o colegiados efectuados por sociedades, asociaciones, colegios profesionales u otras entidades que realicen estas funciones de cobro",
			    CLR_11: "Operaciones de arrendamiento de local de negocio",
			    CLR_14: "Factura con IVA pendiente de devengo en certificaciones de obra cuyo destinatario sea una Administración Pública",
			    CLR_15: "Factura con IVA pendiente de devengo en operaciones de tracto sucesivo",
			    CLR_17: "Operación acogida a alguno de los regímenes previstos en el Capítulo XI del Título IX (OSS e IOSS)",
			    CLR_18: "Recargo de equivalencia",
			    CLR_19: "Operaciones de actividades incluidas en el Régimen Especial de Agricultura, Ganadería y Pesca (REAGYP)",
			    CLR_20: "Régimen simplificado"
			}
    	},    	   	
    },
};

export default translationCa;
